module.exports = __webpack_public_path__ + "static/media/icon-refresh.1bad95d0.svg";